import { render } from "./FormationPage.vue?vue&type=template&id=4768e8a8"
import script from "./FormationPage.vue?vue&type=script&lang=js"
export * from "./FormationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__